// Error boundary component that logs exceptions.
import React from 'react';
import { StyleProp, Text, View, ViewStyle } from 'react-native';
import { logEventAsync } from 'util/eventlog';
import { DatastoreContext } from 'util/datastoreContext';
import { undefR } from 'util/stdtypes';
import { Datastore } from 'util/datastore';

type CatcherProps = {
    children: React.ReactNode;
    style?: StyleProp<ViewStyle>;
}

type CatcherState = {
    error: Error | null;
}

export class Catcher extends React.Component<CatcherProps, CatcherState> {
    static contextType = DatastoreContext;

    constructor(props: CatcherProps) {
        super(props);
        this.state = {error: null};
    }

    async componentDidCatch(error, errorInfo) {
        console.error('componentDidCatch', error, errorInfo);
        if (process.env.NODE_ENV === 'test') {
            throw error;
        }

        this.setState({error});
        const datastore = this.context as Datastore | null;

        await logEventAsync(datastore, 'error', {message: error?.message, stack: error?.stack, componentStack: errorInfo.componentStack});
    }

    render() {
        if (this.state.error) {
            return <View style={this.props.style}>
                <Text>Something went wrong</Text>
                <Text>{this.state.error.message}</Text>
            </View>
        } else {
            return this.props.children;
        }
    }
}

// Remove componentDidCatch in test mode
if (process.env.NODE_ENV === 'test') {
    delete (Catcher.prototype as any).componentDidCatch;
}

export function CatchList({items, renderItem, style = undefR}) {
    return <View style={style}>
        {items && items.map((item, idx) => 
            <Catcher key={item.key}>
                {renderItem(item, idx == items.length-1)}
            </Catcher>
        )}
    </View>
}

export function FailTest(){ 
    throw Error('FailTest');
}
